import React from 'react';
import { Menu } from 'lucide-react';
import { useSidebar } from '../lib/sidebar';

interface TopBarProps {
  title: string;
  actions?: React.ReactNode;
}

export function TopBar({ title, actions }: TopBarProps) {
  const { toggle } = useSidebar();
  return (
    <header
      className="h-14 flex items-center justify-between px-4 md:px-6 border-b border-tg-border sticky top-0 z-20"
      style={{ background: 'var(--tg-bg)' }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <button
          onClick={toggle}
          className="md:hidden text-tg-text-secondary p-1"
          aria-label="Open menu"
        >
          <Menu size={20} />
        </button>
        <h1 className="text-base font-semibold text-tg-text truncate">{title}</h1>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  );
}
